import usePageTitle from "../utils/usePageTitle";
import { useRecentQuestions } from "../watchlist/recentQuestions";
import { useTranslation } from "react-i18next";
import { useEffect, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import { type QuestionSelection, useAskSidebar } from "../chat/AskContext";

/** The shared conversation panel owns the full-page chat route too. */
export default function ChatPage() {
  const { t } = useTranslation();
  const { key, state } = useLocation();
  const activatedLocation = useRef<string | null>(null);
  const { questionId } = useParams();
  const recent = useRecentQuestions().find(question => question.id === questionId);
  usePageTitle(recent?.title.trim() || t("dashboard.ask"));
  const { conversationId, initialized, open, openQuestion } = useAskSidebar();
  useEffect(() => {
    // Router navigation can commit after the conversation state. Only activate
    // on arrival, never reopen the old URL while a new conversation is loading.
    if (activatedLocation.current === key) return;
    activatedLocation.current = key;
    if (!questionId) openQuestion((state as QuestionSelection | null) ?? {});
    else if (!initialized || !open || questionId !== conversationId)
      openQuestion({ ...(state as QuestionSelection | null), questionId });
  }, [key, state, questionId, conversationId, initialized, open, openQuestion]);
  return null;
}
